import { z } from 'zod';

export const schema = z.object({
	numOfShares: z.number().refine((val) => val >= 100 && val % 100 === 0, {
		message: 'For SGX-listed stocks, minimum purchase is 100 shares and in multiples of 100.'
	})
});
